'use client'

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner data-component-id="src/components/ui/sonner.tsx:17:4" data-component-path="src/components/ui/sonner.tsx" data-component-line="17" data-component-end-line="36" data-component-file="sonner.tsx" data-component-name="Sonner" data-component-content="%7B%22elementName%22%3A%22Sonner%22%2C%22className%22%3A%22toaster%20group%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon data-component-id="src/components/ui/sonner.tsx:21:17" data-component-path="src/components/ui/sonner.tsx" data-component-line="21" data-component-end-line="21" data-component-file="sonner.tsx" data-component-name="CircleCheckIcon" data-component-content="%7B%22elementName%22%3A%22CircleCheckIcon%22%2C%22className%22%3A%22size-4%22%7D" className="size-4" />,
        info: <InfoIcon data-component-id="src/components/ui/sonner.tsx:22:14" data-component-path="src/components/ui/sonner.tsx" data-component-line="22" data-component-end-line="22" data-component-file="sonner.tsx" data-component-name="InfoIcon" data-component-content="%7B%22elementName%22%3A%22InfoIcon%22%2C%22className%22%3A%22size-4%22%7D" className="size-4" />,
        warning: <TriangleAlertIcon data-component-id="src/components/ui/sonner.tsx:23:17" data-component-path="src/components/ui/sonner.tsx" data-component-line="23" data-component-end-line="23" data-component-file="sonner.tsx" data-component-name="TriangleAlertIcon" data-component-content="%7B%22elementName%22%3A%22TriangleAlertIcon%22%2C%22className%22%3A%22size-4%22%7D" className="size-4" />,
        error: <OctagonXIcon data-component-id="src/components/ui/sonner.tsx:24:15" data-component-path="src/components/ui/sonner.tsx" data-component-line="24" data-component-end-line="24" data-component-file="sonner.tsx" data-component-name="OctagonXIcon" data-component-content="%7B%22elementName%22%3A%22OctagonXIcon%22%2C%22className%22%3A%22size-4%22%7D" className="size-4" />,
        loading: <Loader2Icon data-component-id="src/components/ui/sonner.tsx:25:17" data-component-path="src/components/ui/sonner.tsx" data-component-line="25" data-component-end-line="25" data-component-file="sonner.tsx" data-component-name="Loader2Icon" data-component-content="%7B%22elementName%22%3A%22Loader2Icon%22%2C%22className%22%3A%22size-4%20animate-spin%22%7D" className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
